import { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Portal from "./components/Portal";
import Override from "./components/Override";
import InfoPage from "./components/InfoPage";
import Reactions from "./components/Reactions";
import LanguageSelect from "./components/LanguageSelect";
import CompletionPage from "./components/CompletionPage";
import RegistrationPage from "./components/RegistrationPage";
import { AppRoutes, LocalStorageKeys } from "./constants";
import { useAppDispatch, useAppSelector } from "./redux";
import { selectError, selectSuccess, selectIsLoading, getAppInfoAction, selectIsUnderMaintenance } from "./AppSlice";
import {
  selectIsInitialLanguage,
  setCurrentLanguageFromOverride,
} from "./components/LanguageSelect/LanguageSelectSlice";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Maintenance } from "./components/Maintenance/Maintenance";
import type { Language } from "./types";

function App() {
  const location = useLocation();

  const error = useAppSelector(selectError);
  const success = useAppSelector(selectSuccess);
  const isLoading = useAppSelector(selectIsLoading);
  const isUnderMaintenance = useAppSelector(selectIsUnderMaintenance);
  const isInitialLanguage = useAppSelector(selectIsInitialLanguage);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const start = async () => {
      async function getData() {
        await dispatch(getAppInfoAction());
      }

      await getData();
    };

    start();

    const params = new URLSearchParams(location.search);

    const language = params.get("language");

    if (language && !isInitialLanguage) dispatch(setCurrentLanguageFromOverride(language as Language));
    else if (!isInitialLanguage) {
      const savedLanguage = localStorage.getItem(LocalStorageKeys.language);

      if (savedLanguage) dispatch(setCurrentLanguageFromOverride(savedLanguage as Language));
    }
  }, []);

  return (
    <>
      <Reactions error={error} success={success} isLoading={isLoading} />

      <Header />

      <LanguageSelect />

      <Routes>
        <Route index element={isUnderMaintenance ? <Maintenance /> : <RegistrationPage />} />

        <Route path={AppRoutes.overrideAttempts} element={<Override />} />

        <Route path={AppRoutes.home} element={isUnderMaintenance ? <Maintenance /> : <RegistrationPage />} />

        <Route path={AppRoutes.portal} element={<Portal />} />

        <Route path={AppRoutes.infoPage} element={<InfoPage />} />

        <Route path={AppRoutes.completion} element={<CompletionPage />} />

        <Route path="*" element={<Navigate to={AppRoutes.home} replace />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
